module.exports = __webpack_public_path__ + "img/coins-01.49d87133.svg";